export default{
  name: '班级',
  permissionsKey:"JG-BJ",
  icon: 'fa fa-envelope-open',
  children:{
    classList:{
      name: '班级列表',
      permissionsKey: "JG-BJ-BJLB",
      path: '/class_list/index',
    }

  }

}
